export const PROJECT_NAME = 'youth'

export const PROJECT_URL = `https://udn.com/newmedia/election2020/${PROJECT_NAME}`

export default {
  PROJECT_NAME,
  PROJECT_URL
}
